import React from "react";
import { useTranslation } from 'react-i18next';
import { AllotDetailModel } from "./AllotDetailModel";
import { FormBox } from "./FormBox";
import { TableBox } from "./TableBox";
import { TopButs } from "./TopButs";

export const InternalDetails = (props) => {
    const { t } = useTranslation();
    return (
        <>
            {props && <div className="yh-detail-box">
                <TopButs {...props} />
                <FormBox {...props} />
                <TableBox {...props} />
                <AllotDetailModel {...props} />
            </div>
            }
        </>
    )
}